import { Component, HostListener, output, inject, signal, OnInit, viewChild } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { ThemeService, BreadcrumbService, NotificationService, MockDataService } from '../../services';
import { SearchOverlayComponent } from '../../../shared/components/search-overlay/search-overlay';
import { NotificationPanelComponent } from '../../../shared/components/notification-panel/notification-panel';
import { ToastContainerComponent } from '../../../shared/components/toast/toast';

@Component({
  selector: 'nf-header',
  imports: [MatIconModule, MatButtonModule, RouterLink, SearchOverlayComponent, NotificationPanelComponent, ToastContainerComponent],
  templateUrl: './header.html',
  styleUrl: './header.scss',
})
export class HeaderComponent implements OnInit {
  readonly menuToggle = output<void>();

  protected readonly theme = inject(ThemeService);
  protected readonly breadcrumbs = inject(BreadcrumbService);
  protected readonly notifications = inject(NotificationService);
  private readonly mockData = inject(MockDataService);

  protected readonly searchOpen = signal(false);
  protected readonly notificationPanel = viewChild<NotificationPanelComponent>('notifPanel');

  ngOnInit(): void {
    this.mockData.getNotifications().subscribe(items => {
      for (const n of items) {
        this.notifications.addNotification(n);
      }
    });
  }

  protected openSearch(): void {
    this.searchOpen.set(true);
  }

  protected closeSearch(): void {
    this.searchOpen.set(false);
  }

  protected toggleNotifications(): void {
    this.notificationPanel()?.toggle();
  }

  @HostListener('document:keydown', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    if ((event.metaKey || event.ctrlKey) && event.key === 'k') {
      event.preventDefault();
      this.searchOpen.set(true);
    }
  }
}
